import * as React from 'react';

import CompanyTypesSvg from '../assets/company-types.svg';

import styles from './help-graphic-closed-lead-company-types.module.css';

export class HelpGraphicClosedLeadCompanyTypes extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles['company-types']}>
                <CompanyTypesSvg />
            </div>
        );
    }
}
